// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1eWKs","buttons":"RemoveExpirationActionButtons_buttons__3B163"};